import { RegisterData } from "@/common/types";
import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";

const register = async (data: RegisterData) => {
  return await axiosInstance
    .post("user/signUp", data)
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useRegisterMutation = () => {
  return useMutation({
    mutationKey: ["user"],
    mutationFn: (values: RegisterData) => register(values),
  });
};

export default useRegisterMutation;
